import type { TypedUseSelectorHook } from 'react-redux'
import { useDispatch, useSelector } from 'react-redux'
import type { AppState } from './app'
import type { DictionarieState } from './dictionarie'
import type { DriverTasksState } from './driverTasks'
import type { EditDictionarieState } from './editDictionarie'

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const appStore = (state: RootState): AppState => state.app
export const driverTasksStore = (state: RootState): DriverTasksState =>
  state.driverTasks
export const dictionarieStore = (state: RootState): DictionarieState =>
  state.dictionarie
export const editDictionarieStore = (state: RootState): EditDictionarieState =>
  state.editDictionarie
